module.exports = __webpack_public_path__ + "static/media/Circle-logo.6e69cbef.svg";